<template>
  <div id="503">
    <h1>503 Forbidden</h1>
  </div>
</template>

<script>
export default {
  name: 'error503'
}
</script>
